<div class="dialog-header-container d-flex align-items-center justify-content-between p-3 border-bottom bg-white">
  <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">{{ inputData.title }}</h2>
  <button mat-icon-button mat-dialog-close (click)="resetForm()" aria-label="Fermer">
    <mat-icon class="text-muted">close</mat-icon>
  </button>
</div>

<mat-dialog-content [formGroup]="compagnieForm" class="p-4 bg-white custom-dialog-content">
  <div class="row g-3">
    
    <!-- Colonne Gauche -->
    <div class="col-12 col-md-6 d-flex flex-column gap-1">
      
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nom</mat-label>
        <input matInput type="text" formControlName="name" placeholder="Entrez le nom de la compagnie">
        @if (compagnieForm.get('name')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Code</mat-label>
        <input matInput type="text" formControlName="code" placeholder="Entrez le code de la compagnie">
        @if (compagnieForm.get('owner')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <div class="file-upload-wrapper my-2 mb-3">
        <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)">
        <button type="button" mat-stroked-button color="primary" [matTooltip]="(compagnieForm.get('logo')?.invalid)?'obligatoire':''" (click)="fileInput.click()" class="w-100 btn-upload-logo">
          <mat-icon class="me-1">cloud_upload</mat-icon>
          <span>Choisir un logo</span>
        </button>
      </div>

      <mat-form-field appearance="outline" class="w-100" *ngIf="fileName">
        <mat-label>Selected File</mat-label>
        <input matInput [value]="fileName" disabled>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Forme Juridique</mat-label>
        <mat-select formControlName="forme">
          <mat-option disabled>Choisir</mat-option>
          <mat-option value="SA">SA</mat-option>
          <mat-option value="SAS">SAS</mat-option>
          <mat-option value="SARL">SARL</mat-option>
          <mat-option value="SCA">SCA</mat-option>
          <mat-option value="MUTUELLE">MUTUELLE</mat-option>
        </mat-select>
        @if (compagnieForm.get('forme')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Capital</mat-label>
        <input matInput formControlName="capital" placeholder="Entrez le montant du capital">
        @if (compagnieForm.get('capital')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>NIU</mat-label>
        <input matInput formControlName="niu" placeholder="Entrez un niu">
        @if (compagnieForm.get('niu')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>



    </div>

    <!-- Colonne Droite -->
    <div class="col-12 col-md-6 d-flex flex-column gap-1">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>RCCM</mat-label>
        <input matInput formControlName="rccm" placeholder="registre de commerce et du credit mobilier">
        @if (compagnieForm.get('rccm')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Adresse</mat-label>
        <input matInput formControlName="adresse" placeholder="Entrez une adresse Yaounde - Bastos">
        @if (compagnieForm.get('adresse')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Agrement</mat-label>
        <input matInput formControlName="agrement" placeholder="Entrez un n* d'agrement">
        @if (compagnieForm.get('agrement')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>B.P</mat-label>
        <input matInput formControlName="bp" placeholder="Entrez une B.P">
        @if (compagnieForm.get('bp')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Tel</mat-label>
        <input matInput formControlName="tel" placeholder="Entrez un n* de telephone">
        @if (compagnieForm.get('tel')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" placeholder="Entrez une email">
        @if (compagnieForm.get('email')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        @if (compagnieForm.get('email')?.hasError('email')) {<mat-error>email invalide</mat-error>}
      </mat-form-field>

    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top bg-light m-0 gap-2">
  <button mat-stroked-button mat-dialog-close color="warn" class="px-4" (click)="resetForm()">Fermer</button>
  
  @if (inputData.update) {
    <button [disabled]="compagnieForm.invalid" mat-flat-button color="primary" class="px-4" (click)="onUpdate()">Modifier</button>
  } @else {
    <button [disabled]="compagnieForm.invalid" mat-flat-button color="primary" class="px-4" (click)="onAdd()">Enregistrer</button>
  }
</mat-dialog-actions>
